// THE HUD DIET (studio cycle 001, specs/001-hud-diet.md, layout specs/m0-hud.md). Everything the new HUD adds is made
// here, behind one body class: body.hud2, on by default. ?hud=1 (kept as localStorage dm_hud=1) leaves it off and shows
// the HUD as it was, for a blind A/B and as the rollback; ?hud=2 clears that and turns it back on. The CSS for it is one
// block at the end of style.css, every selector prefixed body.hud2. The old elements keep their ids and handlers; this
// only adds elements and moves MENU's grid out of the bottom bar.
const $ = (id: string) => document.getElementById(id);
const el = (tag: string, id = '', cls = '', text = '') => { const e = document.createElement(tag); if (id) e.id = id; if (cls) e.className = cls; if (text) e.textContent = text; return e; };

function readFlag(): boolean {
  let off = false;
  try {
    const q = new URLSearchParams(location.search).get('hud');
    if (q === '1') localStorage.setItem('dm_hud', '1');
    else if (q === '2' || q === '0') localStorage.removeItem('dm_hud');
    off = localStorage.getItem('dm_hud') === '1';
  } catch { off = /[?&]hud=1\b/.test(location.search); }
  return !off;
}
/** true: the new HUD (the default); false: ?hud=1, today's HUD */
export const HUD2 = readFlag();
if (HUD2) document.body.classList.add('hud2');

/** studio 005 (specs/005-ui-every-size.md): a desktop's UI grows with the window, --ui on :root (1 at 1024 x 576, 1.25 at
 *  1280 x 720 / 1366 x 768 / 1440 x 900, 1.75 at 1920 x 1080 and capped there, in quarter steps so the pixel fonts stay on a
 *  whole-ish grid; round 3: at 1.0 a 1280 x 720 laptop read 9 px text). style.css zooms the HUD's boxes, the panels, the
 *  dialog and the select screen by it; a phone keeps 1 (its sizes were set for it). */
export function uiScale() {
  const root = document.documentElement;
  const set = () => {
    const k = document.body.classList.contains('touch') ? 1 : Math.min(1.75, Math.max(1, Math.min(innerWidth / 1024, innerHeight / 576)));
    const q = String(Math.floor(k * 4 + 1e-6) / 4);
    if (root.style.getPropertyValue('--ui') !== q) root.style.setProperty('--ui', q);
  };
  set(); addEventListener('resize', set);
}

/** the elements the new HUD adds (only under hud2: ?hud=1 gets exactly today's DOM) */
export function hud2Build() {
  if (!HUD2 || $('bars')) return;
  const hud = $('hud')!;
  // (e) top-left bars: HP with its number inside, the resource, XP, stamina (only when not full)
  const bars = el('div', 'bars');
  const hp = el('div', '', 'hpb'); hp.append(el('i', 'bar-hp', 'f'), el('span', 'bar-hp-n', 'n'));
  const rs = el('div', '', 'rsb'); rs.append(el('i', 'bar-res', 'f'));
  const xp = el('div', '', 'xpb'); xp.append(el('i', 'bar-xp', 'f'));
  const st = el('div', 'bar-stam-w', 'stb full'); st.append(el('i', 'bar-stam', 'f'));
  bars.append(hp, rs, xp, st);
  bars.setAttribute('aria-label', 'Health');
  hud.prepend(bars);
  // (f) the objective line
  const ob = el('div', 'objective'); ob.setAttribute('role', 'button'); ob.tabIndex = 0; ob.hidden = true;
  ob.append(el('span', '', 'ot'), el('span', '', 'oc'), el('span', '', 'oa', '>'));
  bars.after(ob);
  // a tap opens the STORY sheet, the same way MENU > STORY does (the story card's own 'story-menu': pinned open, shown as a
  // sheet, a second tap folds it); with no story card (a job, the NEXT ghost) or on a desktop it shows the quest cards
  const openStory = () => {
    const s = document.querySelector('#tracker .q.story');
    if (document.body.classList.contains('touch') && s) s.dispatchEvent(new CustomEvent('story-menu'));
    else document.body.classList.toggle('story-open');
  };
  ob.addEventListener('click', openStory);
  ob.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openStory(); } });
  addEventListener('pointerdown', (e) => { if (document.body.classList.contains('story-open') && !(e.target as HTMLElement)?.closest?.('#objective, #tracker, #menu')) document.body.classList.remove('story-open'); });
  // (c) the pad: skill A, skill B and HEAL join PRIMARY and DODGE in an arc
  const pad = $('pad')!;
  for (const [id, lab] of [['btn-sk1', ''], ['btn-sk2', ''], ['btn-heal', 'HEAL']]) {
    const b = el('button', id, 'arc', '') as HTMLButtonElement; b.type = 'button'; b.hidden = true;
    b.append(el('span', '', 'n', lab)); if (id !== 'btn-heal') b.append(el('i', '', 'c'));
    pad.append(b);
  }
  // (k) a desktop's moodles sit over the HP globe: its place is measured when the bottom bar or the window changes size
  if (!document.body.classList.contains('touch')) {
    const put = () => { const o = document.querySelector<HTMLElement>('#bottom .orb.hp'), m = $('moodles'); if (!o || !m) return; const r = o.getBoundingClientRect(); if (!r.width) return;
      const x = `${Math.round(r.left)}px`, y = `${Math.round(innerHeight - r.top + 6)}px`; if (m.style.getPropertyValue('--mx') !== x) m.style.setProperty('--mx', x); if (m.style.getPropertyValue('--my') !== y) m.style.setProperty('--my', y); };
    addEventListener('resize', put);
    // (the bar is centred: the globe moves when the belt or the globe itself changes size, never the full-width #bottom)
    if (typeof ResizeObserver !== 'undefined') { const ro = new ResizeObserver(put); for (const q of ['#bottom', '#mid', '#belt', '#bottom .orb.hp']) { const e = document.querySelector(q); if (e) ro.observe(e); } }
    (document as any).fonts?.ready?.then(put).catch(() => {});
    new MutationObserver(put).observe($('hud')!, { attributes: true, attributeFilter: ['hidden'] }); put();
  }
  // (b) the hold list: up to three pills over PRIMARY while it is held
  const hl = el('div', 'holdlist'); hl.hidden = true; hud.append(hl);
}

/** (g) MENU on the new HUD: a three-bar icon; its grid (STORY, PACK, CRAFT, ME, OPTIONS, CHAT, MAP, SNEAK) in a box of its
 *  own under it (a phone: top right under the minimap; a desktop: over the belt's right end). The buttons keep their ids
 *  and handlers; hudfit.ts foldMenu() still opens and closes it (#menu.open). */
export function hud2Menu(act: { map: () => void; sneak: () => void; sneaking: () => boolean }) {
  if (!HUD2) return;
  const menu = $('menu'), b = $('btn-menu'); if (!menu || !b || $('menu-grid')) return;
  b.textContent = ''; for (let i = 0; i < 3; i++) b.append(el('i')); b.setAttribute('aria-label', 'MENU'); b.title = 'Menu';
  const grid = el('div', 'menu-grid');
  const mk = (id: string, t: string, f: () => void) => { const x = el('button', id, '', t) as HTMLButtonElement; x.type = 'button'; x.addEventListener('click', f); return x; };
  const map = mk('btn-menu-map', 'MAP', act.map);
  const snk = mk('btn-menu-sneak', 'SNEAK', () => { act.sneak(); });
  const hadStory = !!$('btn-menu-story');
  // the order of the grid: STORY first, then the panels, then the rest
  for (const id of ['btn-menu-story', 'btn-bag', 'btn-craft', 'btn-me', 'btn-opts', 'btn-menu-chat']) { const x = $(id); if (x) grid.append(x); }
  grid.append(map, snk);
  // a desktop never had STORY or CHAT in the menu (hudfit.ts makes them on a touch screen only): STORY opens the quest
  // cards there too, so the objective line is not the only way to them
  if (!hadStory) { const s = mk('btn-menu-story', 'STORY', () => $('objective')?.click()); grid.prepend(s); }
  menu.append(grid);
  // on a phone MENU lives top right, out of the bottom bar (which hud2 hides on a touch screen)
  if (document.body.classList.contains('touch')) $('hud')!.append(menu);
  // the grid's SNEAK says STAND while you sneak
  new MutationObserver(() => { const t = act.sneaking() ? 'STAND' : 'SNEAK'; if (snk.textContent !== t) snk.textContent = t; }).observe(menu, { attributes: true, attributeFilter: ['class'] });
}

/** the quest the objective line shows, and how it is cut to one line (ui.ts onQuests fills it) */
export interface ObjectiveQ { title: string; text: string; got: number; need: number }
let objQ: ObjectiveQ | null = null, objWatch = false;
export function setObjective(q: ObjectiveQ | null) {
  objQ = q; fitObjective();
  if (!objWatch) { objWatch = true; addEventListener('resize', () => fitObjective()); (document as any).fonts?.ready?.then(() => fitObjective()).catch(() => {}); }
}
/** the step text if it fits one line at this width, else its last sentence if that fits, else the quest title; then the
 *  count in gold when need > 1, then '>' (measured on scrollWidth, only when the quest or the width changes) */
export function fitObjective() {
  const ob = $('objective'); if (!ob) return;
  const q = objQ;
  if (!q || !(q.text || q.title)) { if (!ob.hidden) ob.hidden = true; return; }
  ob.hidden = false;
  const [t, c] = [ob.querySelector<HTMLElement>('.ot')!, ob.querySelector<HTMLElement>('.oc')!];
  const cnt = q.need > 1 ? ` ${q.got}/${q.need}` : '';
  if (c.textContent !== cnt) c.textContent = cnt;
  const text = q.text.trim().replace(/\s*\(\d+\/\d+\)\s*$/, '');
  const sentences = text.match(/[^.!?]+[.!?]+["')\]]*|[^.!?]+$/g)?.map(s => s.trim()).filter(Boolean) ?? [];
  const last = sentences.length > 1 ? sentences[sentences.length - 1] : '';
  const fits = () => t.scrollWidth <= t.clientWidth + 1;   // (the text span is the part that gives in the row)
  const tries = [text, last, q.title].filter(Boolean);
  let pick = tries[tries.length - 1];
  for (const s of tries) { t.textContent = s; if (!t.clientWidth || fits()) { pick = s; break; } }
  if (t.textContent !== pick) t.textContent = pick;
  ob.setAttribute('aria-label', `Objective: ${text || q.title}${cnt}. Opens the story.`);
}
